/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Privacy_Policy_HintInputs */

const en_us2_profile_privacy_policy_hint = /** @type {(inputs: Profile_Privacy_Policy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we keep, why, and your rights`)
};

const pt_br2_profile_privacy_policy_hint = /** @type {(inputs: Profile_Privacy_Policy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que guardamos, por quê e seus direitos`)
};

const es_419_profile_privacy_policy_hint = /** @type {(inputs: Profile_Privacy_Policy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué guardamos, por qué y tus derechos`)
};

const pt_pt2_profile_privacy_policy_hint = /** @type {(inputs: Profile_Privacy_Policy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que guardamos, porquê e os teus direitos`)
};

const fr_fr2_profile_privacy_policy_hint = /** @type {(inputs: Profile_Privacy_Policy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que nous gardons, pourquoi, et tes droits`)
};

const de_de2_profile_privacy_policy_hint = /** @type {(inputs: Profile_Privacy_Policy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was wir speichern, warum, und deine Rechte`)
};

const it_it2_profile_privacy_policy_hint = /** @type {(inputs: Profile_Privacy_Policy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa conserviamo, perché e i tuoi diritti`)
};

/**
* | output |
* | --- |
* | "What we keep, why, and your rights" |
*
* @param {Profile_Privacy_Policy_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_privacy_policy_hint = /** @type {((inputs?: Profile_Privacy_Policy_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Privacy_Policy_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_privacy_policy_hint(inputs)
	if (locale === "es-419") return es_419_profile_privacy_policy_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_privacy_policy_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_privacy_policy_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_privacy_policy_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_privacy_policy_hint(inputs)
	return en_us2_profile_privacy_policy_hint(inputs)
});
export { profile_privacy_policy_hint as "profile.privacy_policy_hint" }